import { LegendVariant } from '../FormHelper/Fieldset/Legend';
import { Fieldset } from '../FormHelper/Fieldset';
import { Checkbox, Option } from './Checkbox';
import React, { useId } from 'react';
import tw from 'twin.macro';

export interface Props<T> {
  value: T[];
  onChange: (value: T[]) => void;
  options: Option<T>[];
  formGroupClassName?: string;
  className?: string;
  label?: string;
  condensed?: boolean;
  minCheckedOptions?: number;
  legendVariant?: LegendVariant;
}
export function Checkboxes<T>(props: Props<T>) {
  const {
    options,
    value,
    onChange,
    className,
    condensed,
    label,
    minCheckedOptions,
    legendVariant = 'quiet',
  } = props;
  const reactId = useId();
  const groupId = `checkboxes-${reactId}`;

  return (
    <Fieldset className={className} label={label} legendVariant={legendVariant}>
      <div css={[condensed && tw`space-y-1`, !condensed && tw`space-y-2`]}>
        {options.map((opt, index) => {
          const id = `${groupId}-${index}`;

          return (
            <Checkbox
              key={`${opt.value}`}
              id={id}
              label={opt.label}
              checked={value.includes(opt.value)}
              description={opt.description}
              onChange={() => {
                const newValue = value.includes(opt.value)
                  ? value.filter(v => v !== opt.value)
                  : [...value, opt.value];
                if (
                  !minCheckedOptions ||
                  newValue.length >= minCheckedOptions
                ) {
                  onChange(newValue);
                }
              }}
            />
          );
        })}
      </div>
    </Fieldset>
  );
}
